import PropTypes from 'prop-types'
import ModulesPanel from '@/containers/SubscriptionFormPage/ModulesPanel/ModulesPanel'
import FormHeader from '@/shared/components/FormHeader/FormHeader'
import { StyledForm } from './styled-components'
import useSubscriptionForm from './useSubscriptionForm'

const SubscriptionForm = ({ id, loadViewParametersRoute, country, applicationType }) => {
  useSubscriptionForm({ initUrl: loadViewParametersRoute, id })

  return (
    <StyledForm>
      <FormHeader applicationType={applicationType} />
      <ModulesPanel country={country} applicationType={applicationType} />
    </StyledForm>
  )
}

SubscriptionForm.propTypes = {
  id: PropTypes.string,
  loadViewParametersRoute: PropTypes.string,
  country: PropTypes.string,
  applicationType: PropTypes.string,
}

export default SubscriptionForm
